module.exports = __webpack_public_path__ + "img/nftkey.bb9aeb8c.png";